import React from 'react';
import { IRovLabelResult } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/rovLabel/IRovLabelResult';
import { EditPanelCell, EditPanelRow, PanelBody, PanelHeading, PanelWithoutForm } from '../../../components/elements';
import { useReactAsync } from '../../../components/utils/useReactAsync';
import { fetchGet } from '../../../store/fetch';
import { GenericInspectionLabel } from '../common/GenericInspectionLabel';

async function loadInspectionStandardData({ surveyId }: { surveyId: string }) {
    const result = await fetchGet(`/api/surveys/${surveyId}/inspectionStandardData/rovLabel`);
    return result.json as IRovLabelResult;
}

export function SurveyDetailsRovLabel(props: { surveyId: string }) {
    const { data } = useReactAsync(loadInspectionStandardData, { surveyId: props.surveyId }, []);

    if (!data) {
        return null;
    }

    return (
        <PanelWithoutForm id="rovLabel">
            <link href="https://fonts.googleapis.com/css?family=Bitter:400,400italic,700" rel="stylesheet" type="text/css"></link>
            <PanelHeading text="ROV label" icon="fa fa-tag"></PanelHeading>
            <PanelBody whiteBackground={true}>
                <EditPanelRow>
                    <EditPanelCell rowCount={6}>
                        <GenericInspectionLabel
                            deHinderVoorHetWegverkeerCategorie={data.reguliereInspectieDeHinderVoorHetWegverkeerCategorie}
                            deHinderVoorHetWegverkeerKlasse={data.reguliereInspectieDeHinderVoorHetWegverkeerKlasse}
                            deHinderVoorHetWegverkeerLabelScore={data.reguliereInspectieDeHinderVoorHetWegverkeerRovLabelScore}
                            inspectionType="scuba"
                            kosten={data.reguliereInspectieKosten}
                            kostenLabelScore={data.reguliereInspectieKostenRovLabelScore}
                            locatie={data.locatie}
                            milieuLabelScore={data.reguliereInspectieMilieuRovLabelScore}
                            naam={data.naam}
                            omschrijving={data.omschrijving}
                            overallLabelScore={data.reguliereInspectieOverallRovLabelScore}
                            rendementLabelScore={data.reguliereInspectieRendementRovLabelScore}
                            veiligheidsrisicoscoreVanDeVaarWeggebruikerLabelScore={
                                data.reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerRovLabelScore
                            }
                            veiligheidsrisicoscoreVanDeVaarWeggebruikerScore={data.reguliereInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore}
                            veiligheidsrisicoscoreVanHetObjectLabelScore={data.reguliereInspectieVeiligheidsrisicoscoreVanHetObjectRovLabelScore}
                            veiligheidsrisicoscoreVanHetObjectScore={data.reguliereInspectieVeiligheidsrisicoscoreVanHetObjectScore}
                            veiligheidsrisicoscoreVoorDeInspecteurLabelScore={
                                data.reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurRovLabelScore
                            }
                            veiligheidsrisicoscoreVoorDeInspecteurScore={data.reguliereInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore}
                        />
                    </EditPanelCell>

                    <EditPanelCell rowCount={6}>
                        <GenericInspectionLabel
                            deHinderVoorHetWegverkeerCategorie={data.rovInspectieDeHinderVoorHetWegverkeerCategorie}
                            deHinderVoorHetWegverkeerKlasse={data.rovInspectieDeHinderVoorHetWegverkeerKlasse}
                            deHinderVoorHetWegverkeerLabelScore={data.rovInspectieDeHinderVoorHetWegverkeerRovLabelScore}
                            inspectionType="rov"
                            kosten={data.rovInspectieKosten}
                            kostenLabelScore={data.rovInspectieKostenRovLabelScore}
                            locatie={data.locatie}
                            milieuLabelScore={data.rovInspectieMilieuRovLabelScore}
                            naam={data.naam}
                            omschrijving={data.omschrijving}
                            overallLabelScore={data.rovInspectieOverallRovLabelScore}
                            rendementLabelScore={data.rovInspectieRendementRovLabelScore}
                            veiligheidsrisicoscoreVanDeVaarWeggebruikerLabelScore={
                                data.rovInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerRovLabelScore
                            }
                            veiligheidsrisicoscoreVanDeVaarWeggebruikerScore={data.rovInspectieVeiligheidsrisicoscoreVanDeVaarWeggebruikerScore}
                            veiligheidsrisicoscoreVanHetObjectLabelScore={data.rovInspectieVeiligheidsrisicoscoreVanHetObjectRovLabelScore}
                            veiligheidsrisicoscoreVanHetObjectScore={data.rovInspectieVeiligheidsrisicoscoreVanHetObjectScore}
                            veiligheidsrisicoscoreVoorDeInspecteurLabelScore={data.rovInspectieVeiligheidsrisicoscoreVoorDeInspecteurRovLabelScore}
                            veiligheidsrisicoscoreVoorDeInspecteurScore={data.rovInspectieVeiligheidsrisicoscoreVoorDeInspecteurScore}
                        />
                    </EditPanelCell>
                </EditPanelRow>
            </PanelBody>
        </PanelWithoutForm>
    );
}
